import React from "react";

export default function Loan() {
  return (
    <div className="loan-page">

      {/* HERO */}
      <div className="loan-hero">
        <h1>લોન યોજના</h1>
        <p>
          અમારી સોસાયટી સભ્યોને ઝડપી, સુરક્ષિત અને સરળ લોન સુવિધા આપે છે.
          તમારા વ્યક્તિગત, ઘરેલુ અને વ્યાવસાયિક જરૂરિયાતો માટે યોગ્ય ઉકેલ.
        </p>
      </div>

      {/* HIGHLIGHT */}
      <div className="loan-highlight">
        <h2>₹50,000 સુધી તરત લોન</h2>
        <p>
          ઓછા વ્યાજ દર, ઝડપી મંજૂરી અને સરળ પ્રક્રિયા સાથે લોન મેળવો.
        </p>
      </div>

      {/* LOAN TYPES */}
      <div className="loan-section">
        <h2>લોનના પ્રકાર</h2>

        <div className="loan-cards">
          <div className="loan-card">
            <h3>સામાન ધિરાણ</h3>
            <p>₹2,00,000 સુધી</p>
            <small>ઘરેલુ વસ્તુઓ માટે લોન</small>
          </div>

          <div className="loan-card">
            <h3>પ્રોપર્ટી ધિરાણ</h3>
            <p>₹5,00,000 સુધી</p>
            <small>જમીન/મકાન માટે</small>
          </div>

          <div className="loan-card">
            <h3>ગોલ્ડ ધિરાણ</h3>
            <p>₹2,00,000 સુધી</p>
            <small>સોનાની સામે તરત લોન</small>
          </div>

          <div className="loan-card">
            <h3>વ્યક્તિગત લોન</h3>
            <p>₹4,00,000 સુધી</p>
            <small>વ્યક્તિગત જરૂરિયાતો માટે</small>
          </div>

          <div className="loan-card">
            <h3>આકસ્મિક લોન</h3>
            <p>₹25,000 સુધી</p>
            <small>તાત્કાલિક મદદ માટે</small>
          </div>
        </div>
      </div>

      {/* BENEFITS */}
      <div className="loan-section">
        <h2>અમારા ફાયદા</h2>
        <div className="loan-cards">
          <div className="loan-card">ઝડપી મંજૂરી</div>
          <div className="loan-card">ઓછા વ્યાજ દર</div>
          <div className="loan-card">સરળ પ્રક્રિયા</div>
          <div className="loan-card">વિશ્વાસપૂર્ણ સેવા</div>
        </div>
      </div>

      {/* OFFER */}
      <div className="loan-offer">
        <h2>ખાસ ઓફર</h2>
        <p>
          4 સભ્યોનો ગ્રુપ બનાવો અને ₹50,000 સુધી તરત લોન મેળવો.
        </p>
      </div>

      {/* INSURANCE */}
      <div className="loan-insurance">
  <h2>વીમા સુરક્ષા</h2>
  <p>
    ₹3,00,000 સુધી વીમા સુરક્ષા — તમારા અને તમારા પરિવાર માટે સંપૂર્ણ સલામતી.
  </p>
</div>

<div className="loan-rules">
  <h2>મુખ્ય નિયમો</h2>
  <ul>
    <li>સભ્ય બનવું ફરજિયાત છે</li>
    <li>લોન સમયસર ચુકવવી પડશે</li>
    <li>વ્યાજ દર નિયમ મુજબ લાગુ પડશે</li>
    <li>દસ્તાવેજો પૂર્ણ હોવા જરૂરી</li>
  </ul>
</div>

<div className="loan-docs">
  <h2>જરૂરી દસ્તાવેજો</h2>
  <ul>
    <li>આધાર કાર્ડ</li>
    <li>પાન કાર્ડ</li>
    <li>ફોટોગ્રાફ</li>
    <li>સરનામું પુરાવો</li>
  </ul>
</div>

      {/* CTA */}
      <div className="loan-cta">
        <h2>હવે અરજી કરો</h2>
        <p>તમારા સપનાઓને સાકાર બનાવવા આજે જ લોન લો</p>
        <button>અરજી કરો</button>
      </div>

    </div>
  );
}